import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8683d35a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "about" }
const _hoisted_2 = {
  key: 0,
  class: "bigTitle"
}
const _hoisted_3 = {
  key: 1,
  class: "bigTitle"
}
const _hoisted_4 = {
  key: 2,
  class: "bigTitle"
}
const _hoisted_5 = {
  key: 3,
  class: "bigTitle"
}
const _hoisted_6 = { class: "radioBox" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ip" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($props.postaimqus <= 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "诊断探索"))
        : _createCommentVNode("", true),
      ($props.postaimqus == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "治疗方案"))
        : _createCommentVNode("", true),
      ($props.postaimqus == 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "治疗方案"))
        : _createCommentVNode("", true),
      ($props.postaimqus == 6)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "思考"))
        : _createCommentVNode("", true),
      _createElementVNode("h1", null, _toDisplayString($data.questions[$props.postaimqus].bigTitle), 1),
      _createVNode(_component_van_radio_group, {
        modelValue: $data.radioVal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.radioVal) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions[$props.postaimqus].radioList, (items, index) => {
              return (_openBlock(), _createBlock(_component_van_radio, {
                key: index,
                "checked-color": "#166938",
                value: items.name,
                name: items.name
              }, {
                icon: _withCtx((props) => [
                  _createElementVNode("img", {
                    class: "img-icon",
                    src: props.checked ? $data.activeIcon : $data.inactiveIcon
                  }, null, 8, _hoisted_7)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(items.title), 1)
                ]),
                _: 2
              }, 1032, ["value", "name"]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.nexStept,
        width: "5.64rem",
        height: "1.3333rem",
        src: require('../assets/button.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ]),
    _hoisted_9
  ], 64))
}